const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式连续阅读',
    desc: '无需翻页点击，滚动即可畅读布丁漫画全集，从开头到最新话一滑到底，沉浸式阅读体验让追漫更过瘾。',
  },
  {
    icon: 'ri-book-open-line',
    title: '海量全集免费看',
    desc: '收录20000+布丁漫画全集，涵盖韩漫、日漫、国漫热门作品，布丁漫画下拉式免费看，全集持续扩充中。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日同步追更',
    desc: '热门连载每日实时更新，第一时间推送最新话。布丁漫画连续阅读模式下，更新内容自动衔接，追更不中断。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步畅读',
    desc: '电脑、平板、手机全适配，阅读进度云端同步。无论用什么设备打开布丁漫画网，都能接着上次继续看。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            阅读体验
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            布丁漫画网重新定义漫画阅读方式，四大核心体验让追漫成为一种享受
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}